export default __webpack_public_path__ + "static/media/MNSGK02.18c63910.png";